import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import { Subscription } from "rxjs";
import { NumberToWordsPipe } from "../numbers-to-words.pipe";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import startCase from "lodash/startCase";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'invoice',
  template: ``,
  styles: []
})
export class InvoiceComponent {
  public table: any = [];
  public invoiceHeaders: any = [];
  public tableHeaders: any = [];
  public tableData: any = [];
  public pdfHeaders: any;
  public headerAddress: any;
  public dd: any;
  public totalAmount: number;
  public totalAmountInWords: string;
  public subscription: Subscription;
  public numbersToWords;
  public taxDetails: any = {
    total_bill: null,
    tax_amount: null,
    taxable_amount: null,
    discount: null,
    cgst: null,
    sgst: null,
    igst: null
  };
  _headers: any = [];
  _body: any = [];

  static parameters = [NgbActiveModal, HttpClient];
  constructor(public http: HttpClient,public transaction_no: any, public win: Window){
    this.pdfHeaders = {};
    this.dd ={};
    this.headerAddress = {
      buyer: null,
      receiver: null,
      sender: null
    };
    this.totalAmount = 0;
    this.totalAmountInWords = '';
    this.numbersToWords = new NumberToWordsPipe();
  }

  async printInvoice() {
    await this.initPdfHeaders(this.transaction_no);
  }

  async populateTable(doc) {
    let _dd = doc;

    for await(const title of this._headers){
      _dd.content[2].table.body[0].push({
        text: startCase(title).toString(),
        bold: true
      })
      _dd.content[2].table.widths.push('*');
    }

    //populate pdf table with rows relevant to columns
    await this._body.forEach(async (row) => {
      const _tableRow = [];
      await this._headers.forEach((title)=> {
        //map each rows value to columns
        _tableRow.push(row[title]);
      });
      //push whole new row to table
      _dd.content[2].table.body.push(_tableRow);
    });
    pdfMake.createPdf(_dd).open({}, this.win);
  }

  async initPdfHeaders(t) {
    const data = {
      'Transaction_No': t,
      'Unit_id': JSON.parse(window.localStorage.getItem('permission'))[0].Unit_ID
    };

    this.subscription = this.http.post('/api/generateinvoice/getHeaderDetails', data)
    .subscribe(async response => {
      const buyer = response[0].InvoiceDetails.bill_buyer_details;
      const sender = response[0].InvoiceDetails.sender_details;

      this.taxDetails.tax_amount = buyer.Total_Tax;
      this.taxDetails.total_bill = buyer.Total_BillAmount;
      this.taxDetails.taxable_amount = buyer.Total_Amount;
      this.taxDetails.discount = buyer.Total_Discount;

      //Convert null fields to Spaced Strings
      Object.keys(buyer).forEach(function(key) {
        if(buyer[key] === null) {
          buyer[key] = ' ';
        }
      });

      this.pdfHeaders.invoiceDate = buyer.Invoice_Date;
      this.pdfHeaders.invoiceNumber = buyer.Invoice_No;
      this.pdfHeaders.lrNo = buyer.LR_No;
      this.pdfHeaders.lrDate = buyer.LR_Date;
      this.pdfHeaders.orderNo = buyer.OrderNo;
      this.pdfHeaders.orderDate = buyer.OrderDate;
      this.pdfHeaders.paymentDetails = buyer.PayMode_ID;
      this.pdfHeaders.dueDate = buyer.Due_Date;
  
      this.totalAmount = parseInt(buyer.Total_BillAmount);
      this.headerAddress.buyer = {
        name: buyer.Customer_LegalName,
        address: buyer.Customer_Address1 + ' ' + buyer.Customer_Address2 + ' ' + buyer.Customer_Address3,
        city: buyer.City_Desc,
        state: buyer.State_Desc,
        stateId: buyer.State_Id,
        gst: buyer.Customer_GSTNo,
        pincode: buyer.Customer_Pincode,
        contact: {
          email: buyer.Customer_EmailID,
          mobile: buyer.Customer_Mobile,
          contact: buyer.Customer_Contact,
          fax: buyer.Customer_Fax
        }
      };
      this.headerAddress.sender = {
        name: sender.Unit_Name,
        address: sender.Unit_Address1 + ' ' + sender.Unit_Address2 + ' ' + sender.Unit_Address3,
        city: sender.Unit_City,
        district: sender.Unit_District,
        state: sender.Unit_State,
        stateId: sender.Unit_StateId,
        pincode: sender.Unit_Pincode,
        registered_address: 'Regd Office: Ambala - Chandigarh Highways, Lalru-140501, CIN No: L33117PB1984PLC022350, PAN: AAACP5335J, Telephone: 01762-505900,\n Fax:01762-505906, Web-Site-www.panaceabiotec.com Email:corporate@panaceabiotec.com',
        contact: {
          email: sender.Unit_Email,
          telephone: sender.Unit_Telephone
        }
      }
    });

    this.subscription = await this.http.post('/api/generateinvoice/getTransactionDetails', data)
    .subscribe(async response => {
      this._body = response;
      this.taxDetails.cgst = response[0].HSN_cgst;
      this.taxDetails.sgst = response[0].HSN_sgst;
      this.taxDetails.igst = response[0].HSN_igst;

      for(const key in response[0]){
        if(key === 'Transaction_No' || key === 'Product_ID' || key === 'HSN_cgst'|| key === 'HSN_sgst'|| key === 'HSN_igst'){
          continue;
        }
        this._headers.push(key);
      }
      this.totalAmountInWords = startCase(this.numbersToWords.transform(Math.floor(this.totalAmount)));
      this.constructDoc();
    });
  }

  constructDoc() {
    const self = this;
    const _dd = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [ 40, 100, 40, 60 ],
      header: function(currentPage, pageCount, pageSize){
        return [
          {
            alignment: 'center',
            text: 'TAX INVOICE',
            bold: true,
            margin: [0,15]
          },
          {
            columns: [
              {
                ul: [
                  {text: 'Invoice Number', listType: 'none', style:'ulHeader'},
                  {text: 'Invoice Date', listType: 'none', style:'ulHeader'},
                ]
              },
              {
                ul: [
                  { text: self.pdfHeaders.invoiceNumber, listType: 'none', style:'ulValue'},
                  { text: self.pdfHeaders.invoiceDate, listType: 'none', style:'ulValue'},
                ]
              },
              {
                ul: [
                  {text: 'Order No. ', listType: 'none', style:'ulHeader'},
                  {text: 'Order Date ', listType: 'none', style:'ulHeader'},
                ]
              },
              {
                ul: [
                  { text: self.pdfHeaders.orderNo, listType: 'none', style:'ulValue'},
                  { text: self.pdfHeaders.orderDate, listType: 'none', style:'ulValue'},
                ]
              },
              {
                ul: [
                  {text: 'L.R.No', listType: 'none', style:'ulHeader'},
                  {text: 'L.R.Date ', listType: 'none', style:'ulHeader'},
                ]
              },
              {
                ul: [
                  { text: self.pdfHeaders.lrNo, listType: 'none', style:'ulValue'},
                  { text: self.pdfHeaders.lrDate, listType: 'none', style:'ulValue'},
                ]
              },
              {
                ul: [
                  {text: 'Payment mode', listType: 'none', style:'ulHeader'},
                  {text: 'Due Date', listType: 'none', style:'ulHeader'},
                ]             
              },
              {
                ul: [
                  { text: (self.pdfHeaders.paymentDetails === 1) ? 'Cash' : 'Credit', listType: 'none', style:'ulValue'},
                  { text: self.pdfHeaders.dueDate, listType: 'none', style:'ulValue'},
                ]
              },
            ]
          }
        ]
      },
      footer: function(currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              {
                width: '*',
                text: self.headerAddress.sender.registered_address,
                fontSize:8
              },
              {
                width: 'auto',
                text: (currentPage === pageCount) ? 'Authorized Signatory/\nCompetent Person' : currentPage + ' / ' + pageCount , alignment: 'right', style: 'footerPageNumber'
              }
            ],
            margin: [15,0]
          }
        ]
      },
      content: [
          {
            columns: [
              // {
              //   stack: [
              //     {
              //       text: 'Details of Buyer(Billed To)',
              //       style:'addHeader',
              //     },
              //     {
              //       text: self.headerAddress.buyer.name + '\n' +self.headerAddress.buyer.address + '\n' + self.headerAddress.buyer.city + ' - ' + self.headerAddress.buyer.pincode + '\n TEL :' + self.headerAddress.buyer.contact.contact + ' Fax :'+ self.headerAddress.buyer.contact.fax + '\n GST NO: ' + self.headerAddress.buyer.gst + '\n State - ' + self.headerAddress.buyer.state,
              //       style:'addBody'
              //     }
              //   ]
              // },
              {
                stack: [
                  {
                    text: 'Details of Receiver (Shipped To)',
                    style:'addHeader',
                  },
                  {
                    text: self.headerAddress.buyer.name + '\n' +self.headerAddress.buyer.address + '\n' + self.headerAddress.buyer.city + ' - ' + self.headerAddress.buyer.pincode + '\n TEL :' + self.headerAddress.buyer.contact.contact + ' Fax :'+ self.headerAddress.buyer.contact.fax + '\n GST NO: ' + self.headerAddress.buyer.gst + '\n State - ' + self.headerAddress.buyer.state,
                    style:'addBody'
                  }
                ]
              },
              {
                stack: [
                  {
                    text: 'Details of Sender (Billing From)',
                    style:'addHeader'
                  },
                  {
                    text: self.headerAddress.sender.name + '\n' +self.headerAddress.sender.address + '\n' + self.headerAddress.sender.city + ' - ' + self.headerAddress.sender.pincode + '\n TEL :' + self.headerAddress.sender.contact.telephone + '\n State - ' + self.headerAddress.sender.state,
                    style:'addBody'
                  }
                ]
              }
            ],
            margin: [-10,0]
          },
          {
            text:'Place of Supply (in case of Inter-state trade) - '+ self.headerAddress.buyer.state + '\n Name of State : ' + self.headerAddress.sender.state,
            style:'addHeader',
            marginBottom:20,
          },
          {
            layout: 'headerLineOnly',
            margin: [-10,0],
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              headerRows: 1,
              widths: [],
              body: [
                [],
              ]
            }
          },
          {   
            marginTop:12,
            columns: [
              {
                width: 'auto',
                text: 'NET TO PAY(RUPEES): ',
                fontSize:12,
                bold:true
              },
              {
                width: '*',
                text: self.totalAmountInWords,
                fontSize:12,
                bold:true,
                marginLeft:10
              },
              {
                width: 'auto',
                text: self.totalAmount,
                fontSize:12,
                bold:true,
                marginRight: 30
              }
            ]
        },
        {  
          stack:[
              {
                text:'Tax Detail',
                fontSize:12,
                bold:true,
                marginTop:14,
                marginBottom:10,
                characterSpacing:0.4
              },
              {
                table: {
                headerRows: 1,
                body: [
                  [
                    { text: 'Rate %', bold: true },
                    (self.headerAddress.buyer.stateId === self.headerAddress.sender.stateId) ? { text: 'CGST / SGST', bold: true } : { text: 'IGST', bold: true },
                    { text: 'Taxable Amt', bold: true },
                    { text: 'Discount', bold: true },
                    { text: 'Tax Amt', bold: true },
                    { text: 'Total Bill Amt', bold: true }
                  ],
                  [ (self.headerAddress.buyer.stateId === self.headerAddress.sender.stateId) ? self.taxDetails.cgst + self.taxDetails.sgst : self.taxDetails.igst, (self.headerAddress.buyer.stateId === self.headerAddress.sender.stateId) ? self.taxDetails.cgst + ' / ' + self.taxDetails.sgst : self.taxDetails.igst,self.taxDetails.taxable_amount,self.taxDetails.discount,self.taxDetails.tax_amount, self.taxDetails.total_bill ],
                ]
              }
            }
          ]
        }
      ],
      styles: {
        footerPageNumber: {
        //   marginRight: 30
        },
        headerStyle: {
          lineHeight: 0.8,
          letterSpacing: 0.4,
          fontSize: 10
        },
        addHeader:{
          fontSize:13,
          characterSpacing: 0.9,
          bold:true,
        },
        ulHeader:{
          fontSize:9, characterSpacing:0.6, marginBottom:3
        },
        ulValue:{
          fontSize:9, bold:true, characterSpacing:0.6
        },
        addBody:{
          marginBottom:20,
          marginTop:4,
          fontSize:10,
          lineHeight:1.2
        },
        noborder: {
          border: [false, false, false, false]
        }
      }
    };
    this.populateTable(_dd);
  }
}